import View from '@play-co/timestep-core/lib/ui/View';
import StateObserver from 'src/StateObserver';
import BasePopupInstallApp from './BasePopupInstallApp';
import { getLocale } from 'src/replicant/getters/user';
import { Native } from 'src/replicant/native';

export default class PopupInstallAppIos extends BasePopupInstallApp {
  constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      platform: 'ios',
    });
  }

  protected getDownloadBadge() {
    const { user } = StateObserver.getState();
    return getLocale(user) === 'en'
      ? 'assets/native/ios/app_store_button_en.png'
      : 'assets/native/ios/app_store_button_ja.png';
  }

  protected getStoreUrl() {
    return Native.ruleset.appStoreURL;
  }
}
